module.exports = __webpack_public_path__ + "static/media/unicef.f72fb0fe.png";